module.exports = __webpack_public_path__ + "static/media/link.dcbdd5f6.svg";